import StaticStickitView from '../static_stickit_view';

export default StaticStickitView.extend({
  // A view for selecting which dog sizes the sitter needs to accept.
  // The view takes a Query as its model.

  bindings: {
    '.js-search-small_dogs': 'small_dogs',
    '.js-search-medium_dogs': 'medium_dogs',
    '.js-search-large_dogs': 'large_dogs',
    '.js-search-giant_dogs': 'giant_dogs',
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/dog_sizes_view.js